/**
 * ╔══════════════════════════════════════════════════════╗
 * ║  FREE SHIPPING BAR – Drawer Injection                ║
 * ║  Datei speichern als: assets/free-shipping-bar.js    ║
 * ║  Einbinden in: layout/theme.liquid (vor </body>)     ║
 * ╚══════════════════════════════════════════════════════╝
 */

(function () {
  // ── Konfiguration ──────────────────────────────────────
  const THRESHOLD_CENTS = 7000;   // 70 € in Cent — zum Ändern nur diese Zahl anpassen
  const CURRENCY_SYMBOL = '€';    // Währungszeichen

  // Farben — hier anpassen:
  const GOLD_COLOR        = '#8A765D';                           // Balken + Icons
  const BG_COLOR          = 'var(--color-background-secondary)'; // Hintergrund der Box  → passt sich dem Theme an
  const TEXT_COLOR        = 'var(--color-text-secondary)';       // Fließtext            → passt sich dem Theme an
  const TEXT_STRONG_COLOR = 'var(--color-text-primary)';         // Fettschrift (Betrag) → passt sich dem Theme an
  // ───────────────────────────────────────────────────────

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0' + CURRENCY_SYMBOL;
  }

  function buildBarHTML(cartTotalCents) {
    const remaining = THRESHOLD_CENTS - cartTotalCents;
    const progress  = Math.min(100, Math.round((cartTotalCents / THRESHOLD_CENTS) * 100));

    if (remaining <= 0) {
      return `
        <div class="fsb-wrapper" id="fsb-widget">
          <div class="fsb-success">
            <svg class="fsb-icon" viewBox="0 0 18 18" fill="none" aria-hidden="true">
              <circle cx="9" cy="9" r="8" stroke="currentColor" stroke-width="1.4"/>
              <path d="M5.5 9l2.5 2.5 4.5-4.5" stroke="currentColor" stroke-width="1.5"
                stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Gratisversand!</span>
          </div>
        </div>`;
    }

    return `
      <div class="fsb-wrapper" id="fsb-widget">
        <div class="fsb-bar-wrap">
          <p class="fsb-text">
            <svg class="fsb-truck" viewBox="0 0 18 14" fill="none" aria-hidden="true">
              <rect x="1" y="1" width="10" height="9" rx="1" stroke="currentColor" stroke-width="1.3"/>
              <path d="M11 4h2.5L15.5 7v4H11V4z" stroke="currentColor" stroke-width="1.3"
                stroke-linejoin="round"/>
              <circle cx="4" cy="12" r="1.5" stroke="currentColor" stroke-width="1.2"/>
              <circle cx="13" cy="12" r="1.5" stroke="currentColor" stroke-width="1.2"/>
            </svg>
            Noch <strong>${formatMoney(remaining)}</strong> bis zum
            <strong>kostenlosen Versand!</strong>
          </p>
          <div class="fsb-track" role="progressbar"
            aria-valuenow="${progress}" aria-valuemin="0" aria-valuemax="100">
            <div class="fsb-fill" style="width: ${progress}%"></div>
          </div>
        </div>
      </div>`;
  }

  function injectBar(cartTotalCents) {
    const content = document.querySelector('.cart-drawer__content');
    if (!content) return;

    const existing = document.getElementById('fsb-widget');
    const html     = buildBarHTML(cartTotalCents);

    if (existing) {
      existing.outerHTML = html;
    } else {
      content.insertAdjacentHTML('afterbegin', html);
    }
  }

  async function fetchCartTotal() {
    try {
      const res  = await fetch('/cart.js');
      const data = await res.json();
      return data.total_price;
    } catch (e) {
      console.warn('[FSB] Warenkorb konnte nicht geladen werden.', e);
      return 0;
    }
  }

  async function init() {
    injectStyles();

    document.addEventListener('dialog:open', async () => {
      const total = await fetchCartTotal();
      injectBar(total);
    });

    document.addEventListener('cart:updated', async (e) => {
      const total = e.detail?.total_price ?? await fetchCartTotal();
      injectBar(total);
    });

    // Intercept Shopify AJAX cart responses für Live-Updates
    const origFetch = window.fetch;
    window.fetch = async function (...args) {
      const response = await origFetch.apply(this, args);
      const url      = typeof args[0] === 'string' ? args[0] : args[0]?.url ?? '';

      if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
        const clone = response.clone();
        clone.json().then((data) => {
          if (data?.total_price !== undefined) {
            injectBar(data.total_price);
          } else {
            fetchCartTotal().then(injectBar);
          }
        }).catch(() => {});
      }
      return response;
    };
  }

  function injectStyles() {
    if (document.getElementById('fsb-styles')) return;
    const style = document.createElement('style');
    style.id = 'fsb-styles';

    // Farb-Variablen werden als JS-Strings zusammengesetzt,
    // damit CSS-Variablen (var(--...)) korrekt im Stylesheet landen.
    style.textContent = [
      '.fsb-wrapper {',
      '  margin: 14px 16px 6px;',
      '  padding: 12px 14px;',
      '  background: ' + BG_COLOR + ';',
      '  border-radius: 8px;',
      '}',
      '.fsb-text {',
      '  margin: 0 0 10px 0;',
      '  font-size: 13px;',
      '  line-height: 1.5;',
      '  color: ' + TEXT_COLOR + ';',
      '  display: flex;',
      '  align-items: center;',
      '  gap: 6px;',
      '  flex-wrap: wrap;',
      '}',
      '.fsb-text strong { color: ' + TEXT_STRONG_COLOR + '; font-weight: 600; }',
      '.fsb-truck { width: 18px; height: 14px; flex-shrink: 0; color: ' + GOLD_COLOR + '; }',
      '.fsb-track {',
      '  height: 6px;',
      '  background: rgba(138,118,93,0.2);',
      '  border-radius: 99px;',
      '  overflow: hidden;',
      '}',
      '.fsb-fill {',
      '  height: 100%;',
      '  background: ' + GOLD_COLOR + ';',
      '  border-radius: 99px;',
      '  transition: width 0.5s ease;',
      '}',
      '.fsb-success {',
      '  display: flex;',
      '  align-items: center;',
      '  gap: 8px;',
      '  font-size: 13px;',
      '  font-weight: 600;',
      '  color: ' + TEXT_STRONG_COLOR + ';',
      '}',
      '.fsb-icon { width: 18px; height: 18px; flex-shrink: 0; color: ' + GOLD_COLOR + '; }',
    ].join('\n');

    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();